import {
  styled,
  ColorCircle,
  theme,
  breakpoints,
} from '@notino/react-styleguide';

import { COLOR_CIRCLE_SIZE } from './constants';

export const Button = styled.button`
  width: 100%;
  padding: 1rem;

  cursor: pointer;

  background: ${theme.color.background.primary};
  border: 0.1rem solid ${theme.color.border.divider};
`;

export const ShadesVariantsList = styled.ul`
  display: flex;
  flex-wrap: wrap;
`;

export const VariantInfo = styled.div`
  display: flex;
  align-items: center;
`;

export const OffsetScrollDiv = styled.div`
  position: relative;
  top: -4rem;

  @media (min-width: ${breakpoints.md}) {
    top: -40vh;
  }
`;

export const AdditionalInfo = styled.span`
  color: ${theme.color.text.primary};
  margin-left: 1rem;
  font-size: 1rem;
`;

export const TagOrWatchdogWrapper = styled.div`
  margin-left: auto;
`;

export const WatchdogLink = styled.button`
  text-decoration: underline;
  white-space: nowrap;

  background: transparent;
  border: 0;
  font-size: 0.875rem;
`;

export const ChevronWrapper = styled.div`
  margin-left: auto;
`;

export const BorderedColorCircle = styled(ColorCircle)<{
  darkerBorder: boolean;
}>`
  border: 0.1rem solid
    ${({ darkerBorder }) =>
      darkerBorder
        ? theme.color.common.gray30
        : theme.color.common.white} !important;
  min-height: ${COLOR_CIRCLE_SIZE}rem;
  min-width: ${COLOR_CIRCLE_SIZE}rem;
  overflow: hidden;
`;

export const ButtonColorCircle = styled(ColorCircle)`
  min-width: 2rem;
  min-height: 2rem;
`;

export const Title = styled.h4`
  margin: 0;

  font-size: 1rem;
  font-weight: bold;
`;

export const VariantListItem = styled.li`
  width: 100%;

  // override layout styles for li
  padding: 0;
  margin: 0;
  :before {
    content: none;
  }
`;

export const Variant = styled.div<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  padding: 1rem 1.25rem;

  color: ${theme.color.text.primary};

  background: ${(props) =>
    props.isSelected
      ? theme.color.background.tertiary
      : theme.color.background.primary};

  &:hover {
    background: ${(props) =>
      props.isSelected
        ? theme.color.background.tertiary
        : theme.color.background.disabled};
  }
`;

export const VariantListItemInfo = styled.div<{ isOutOfStock: boolean }>`
  display: flex;
  align-items: center;
  margin-right: 1rem;

  ${({ isOutOfStock }) => (isOutOfStock ? 'opacity: 0.25;' : '')}
`;

export const Tag = styled.small`
  color: ${theme.color.text.tertiary};
`;
